import React, {Component} from 'react'
import DefaultTab from './DefaultTab'
import locale from './locale'
import AnnouncementModal from 'template/Modals/Announcement'
import {PanelWrapper, Tab ,Tabs ,TabList ,TabPanel} from 'components/UI'
import {connect} from 'react-redux'
import {searchAnnouncement} from './redux/actions/searchAnnouncement'
import {fetchAnnouncementList} from './redux/actions/getAnnouncementList'
import {setCurrentTabState} from './redux/actions/setCurrentTabState'
import searchAnnouncementCTRL from 'controllers/announcement/searchAnnouncement'
import __R from 'containers/__R';
import FilterBy from 'template/FilterBy';

import './Announcement.scss'

const tabNames = ['all', 'published', 'draft'];
const FILTERS = ['text:searchKeyword'];

const FILTER_OPTIONS = {
  'text:searchKeyword': {
    placeholder: __('Search Announcement', locale),
    valueMinLength: 2,
  }
}
const mapStateToProps = (state) => ({
  currentTabState: state.announcementList.currentTabState
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAnnouncementList: (schoolId, param, amount_per_page, page_number,state,order_by,title_keyword) => dispatch(fetchAnnouncementList(schoolId, param, amount_per_page, page_number,state,order_by,title_keyword)),
    searchAnnouncement: (schoolId, param, amount_per_page, page_number,state, title_keyword) => dispatch(searchAnnouncement(schoolId, param, amount_per_page, page_number,state, title_keyword)),
    setCurrentTabState: (currentTabState) => dispatch(setCurrentTabState(currentTabState))
  }
}

class Announcement extends Component {
  constructor(props){
    super(props)

    this.state ={
      options: [],
      tabIndex: 0,
      orderBy: 0,
      filterData:{},
      keyword: '',
      pagination: {
        activePage: 1
      }
    }
    this.onFilterChange = this.onFilterChange.bind(this)
    setCurrentTabState({tabName:'all', tabIndex:0});
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.currentTabState !== nextProps.currentTabState){
      this.setState({tabIndex: nextProps.currentTabState.tabIndex})
    }
  }

  // onOptionSelected(data){
  //   const schoolId = localStorage.getItem('schoolId')
  //   const { tabIndex } = this.state;
  //   if(!data){
  //     this.setState({selectedOption: ''})
  //     if(tabNames[tabIndex] !== 'all') {
  //       return this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', state: tabNames[tabIndex], amount_per_page: 12, page_number: 1})
  //     }else {
  //       return this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1})
  //     }
  //   }

  //   this.setState({selectedOption: data})
  //   if(tabNames[tabIndex] !== 'all') {
  //     this.props.searchAnnouncement({schoolId: Number(schoolId), param: 'all', amount_per_page:12, page_number: 1, state: tabNames[tabIndex], title_keyword: data.label})
  //   }else {
  //     this.props.searchAnnouncement({schoolId: Number(schoolId), param: 'all', amount_per_page:12, page_number: 1, title_keyword: data.label})
  //   }
  //   this.setState({options: []})
  // }

  // onInputChange(value){
  //   const schoolId = localStorage.getItem('schoolId')
  //   const {tabIndex} = this.state;
  //   if(value == ''){
  //     return value
  //   }
  //   if(tabNames[tabIndex] !== 'all') {
  //     searchAnnouncementCTRL({schoolId: Number(schoolId), param: 'all', amount_per_page:50, page_number: 1, state: tabNames[tabIndex], title_keyword: value})
  //     .then((res) => {
  //       if(res.result_list){
  //         let options = []
  //         res.result_list.map((announcement) => {
  //           options.push({value: announcement.id, label: announcement.title})
  //         })
  //         this.setState({options})
  //       }
  //     })
  //   }else {
  //     searchAnnouncementCTRL({schoolId: Number(schoolId), param: 'all', amount_per_page:50, page_number: 1, title_keyword: value})
  //     .then((res) => {
  //       if(res.result_list){
  //         let options = []
  //         res.result_list.map((announcement) => {
  //           options.push({value: announcement.id, label: announcement.title})
  //         })
  //         this.setState({options})
  //       }
  //     })
  //   }
  // }

  onTabChange(tabIndex) {
    const {setCurrentTabState} = this.props;
    const { orderBy } = this.state;

    let tabName;
    if(tabIndex===0){
      tabName='all';
    }else if (tabIndex===1){
      tabName='published';
    }else {
      tabName='draft'
    }
    setCurrentTabState({tabName, tabIndex});
    this.setState({
      orderBy: orderBy, 
      filterData: {
        ...this.state.filterData,
        searchKeyword: '',
      },
      keyword: ''
    })
  }

  onFilterChange({ filterData }){
    const schoolId = localStorage.getItem('schoolId')
    const {orderBy, tabIndex} = this.state

    this.setState({
      filterData,
      keyword: filterData['searchKeyword']
    },
      ()=>{
        this.props.fetchAnnouncementList({
          schoolId: Number(schoolId),
          param: 'all',
          state: tabNames[tabIndex],
          amount_per_page: 12,
          page_number: 1,
          order_by: orderBy,
          title_keyword: this.state.keyword
        })
      }
    )
  }

  render(){
    const schoolId = localStorage.getItem('schoolId')
    let {tabIndex, filterData, pagination, keyword} = this.state

    return (
      <PanelWrapper className='announcement-container'>
        <div>
          {__("Announcement List", locale)}
        </div>
        <Tabs selectedIndex={tabIndex} onSelect={tabIndex => this.onTabChange(tabIndex)}>
          <TabList>
            <Tab>{__('All', locale)}</Tab>
            <Tab>{__('Published', locale)}</Tab>
            <Tab>{__('Draft', locale)}</Tab>
            <__R can='create_announcement' by='disable'>
              <button bsStyle='primary' className="btn btn-primary pull-right createBtn" onClick={()=>{
                AnnouncementModal({allowEdit: true})
                .then(() => {
                  this.setState({
                    filterData: {
                      ...this.state.filterData,
                      searchKeyword: '',
                    },
                    keyword: ''
                  }, ()=>{
                    this.props.fetchAnnouncementList({
                      schoolId: Number(schoolId),
                      param: 'all',
                      state: tabNames[tabIndex],
                      amount_per_page: 12,
                      page_number: 1,
                      order_by: this.state.orderBy,
                    })
                  })
                })
              }}>
              {__("New Announcement", locale)}
              </button>
            </__R>
            {/* <SearchBar
              selectedOption={selectedOption}
              options={options}
              onOptionSelected={this.onOptionSelected}
              onInputChange={this.onInputChange}
              placeholder={__("Search by title", locale)}
            /> */}
            <div className='pull-right'>
              <FilterBy
                filterData={filterData}
                filters={FILTERS}
                options={FILTER_OPTIONS}
                onChange={this.onFilterChange} />
            </div>
            <select className='form-control sort-by pull-right' value={this.state.orderBy} onChange={(e) => {
              this.setState({orderBy: e.target.value}, ()=>{
                this.props.fetchAnnouncementList({
                  schoolId: Number(schoolId),
                  param: 'all',
                  state: tabNames[tabIndex],
                  amount_per_page: 12,
                  page_number: 1,
                  order_by: this.state.orderBy,
                  title_keyword: keyword
                })
              })
            }}>
              <option key='0' value='0'>{__('Creation Time: Newest to Oldest', locale)}</option>
              <option key='1' value='1'>{__('Creation Time: Oldest to Newest', locale)}</option>
            </select>
            <div className='pull-right sort-by-label'>{__('Sort by', locale)}</div>
          </TabList>

          <TabPanel>
            <DefaultTab announcementState={'all'} orderBy={this.state.orderBy} pagination={pagination} keyword={keyword} />
          </TabPanel>
          <TabPanel>
            <DefaultTab announcementState={'published'} orderBy={this.state.orderBy} pagination={pagination} keyword={keyword} />
          </TabPanel>
          <TabPanel>
            <DefaultTab announcementState={'draft'} orderBy={this.state.orderBy} pagination={pagination} keyword={keyword} />
          </TabPanel>
        </Tabs>
      </PanelWrapper>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Announcement)



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/index.js